/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";

const get = (url, params) =>
  axios.get(API_BASE_URL + url, { params }).then((r) => r.data).catch(() => []);

export default function ProductPicker({ onSelect, compact = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const searchRef = useRef(null);

  /* debounced search in inventory */
  useEffect(() => {
    const q = query.trim();
    if (!q) {
      setResults([]);
      return;
    }
    setSearching(true);
    const t = setTimeout(() => {
      get("/api/material-stock/inventory", { search: q }).then((data) => {
        setResults(Array.isArray(data) ? data : []);
        setSearching(false);
      });
    }, 300);
    return () => clearTimeout(t);
  }, [query]);

  const pick = useCallback((item) => {
    onSelect({
      itemCode: item.itemCode,
      hsnCode: item.hsnCode,
      description: item.productName || item.description,
      category: item.category || "",
      size: item.modelNumber || "",
      poles: "",
      version: item.voltage || "",
      listPrice: item.sellingPrice || item.listPrice || 0,
      unit: item.unit,
      isOnRequest: false,
    });
    setOpen(false);
    setQuery("");
    setResults([]);
  }, [onSelect]);

  return (
    <div className="relative inline-block text-left">
      {compact ? (
        <button
          type="button"
          onClick={() => setOpen((c) => !c)}
          className="flex h-8 w-8 items-center justify-center rounded-[4px] border border-slate-300 bg-white text-slate-600 transition hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus:ring-1 focus:ring-blue-500 shrink-0"
          title={open ? "Close" : "Pick from Inventory"}
        >
          <span className="text-xs">🔍</span>
        </button>
      ) : (
        <button
          type="button"
          onClick={() => setOpen((c) => !c)}
          className="flex items-center gap-1.5 rounded-[4px] border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-blue-500 h-9"
        >
          <span>🔍</span>
          {open ? "Close" : "Pick from Inventory"}
        </button>
      )}

      {open && (
        <div className="absolute z-50 mt-1 rounded-[4px] border border-slate-200 bg-white p-4 shadow-lg left-0 w-[550px] max-w-[90vw] md:w-[750px]">
          <div>
            <input
              ref={searchRef}
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by item code, name, category, voltage..."
              className="w-full rounded-[4px] border border-slate-300 px-3 py-1.5 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 h-9"
            />
            {searching && (
              <p className="mt-2 text-xs text-slate-400">Searching…</p>
            )}
          </div>

          {/* results */}
          {results.length > 0 && (
            <div className="mt-3 max-h-60 max-w-full overflow-x-auto overflow-y-auto rounded-[4px] border border-slate-200">
              <table className="min-w-[700px] w-full text-xs font-sans">
                <thead className="bg-slate-50 text-slate-600 text-left">
                  <tr>
                    <th className="px-3 py-2 border-b border-slate-200">Item Code</th>
                    <th className="px-3 py-2 border-b border-slate-200">Name</th>
                    <th className="px-3 py-2 border-b border-slate-200">Voltage</th>
                    <th className="px-3 py-2 border-b border-slate-200">Category</th>
                    <th className="px-3 py-2 border-b border-slate-200">Stock Type</th>
                    <th className="px-3 py-2 text-right border-b border-slate-200 font-semibold">Price</th>
                    <th className="px-3 py-2 border-b border-slate-200"></th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((p) => (
                    <tr key={p._id} className="border-t border-slate-100 hover:bg-slate-50">
                      <td className="px-3 py-2 font-mono font-semibold text-slate-900">{p.itemCode}</td>
                      <td className="px-3 py-2 text-slate-700">{p.productName}</td>
                      <td className="px-3 py-2 text-slate-700">{p.voltage}</td>
                      <td className="px-3 py-2 text-slate-700">{p.category}</td>
                      <td className="px-3 py-2 text-slate-700 capitalize">{p.stockCategory}</td>
                      <td className="px-3 py-2 text-right font-semibold text-slate-900">
                        {`₹${Number(p.sellingPrice || p.listPrice || 0).toLocaleString("en-IN")}`}
                      </td>
                      <td className="px-3 py-2">
                        <button
                          type="button"
                          onClick={() => pick(p)}
                          className="rounded-[4px] bg-slate-800 px-3 py-1 text-xs font-semibold text-white hover:bg-slate-700"
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {query.trim() && !searching && results.length === 0 && (
            <p className="mt-3 text-center text-xs text-slate-400">No items found for "{query}"</p>
          )}
        </div>
      )}
    </div>
  );
}
